
{
  "familyId": "GET-NEGATIEF",
  "questions": [
    {
      "id": "GET-NEGATIEF-001",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Welk getal is kleiner: -5 of -2?",
      "context": null,
      "options": ["-5", "-2", "ze zijn even groot", "dat kun je niet zeggen"],
      "correctAnswer": 0,
      "conceptId": "negative_compare_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-5, -2, 0],
            "label": "Getallenlijn met -5 en -2",
            "start": -10,
            "end": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-5, -2, 0],
            "highlight": [-5],
            "arrows": [
              {
                "from": -5,
                "to": -2,
                "label": "-5 staat links van -2, dus -5 is kleiner"
              }
            ],
            "label": "Hoe verder naar links op de getallenlijn, hoe kleiner het getal",
            "start": -10,
            "end": 5
          }
        }
      ],
      "feedback": {
        "explanationText": "Kijk naar de getallenlijn. -5 staat links van -2. Hoe verder naar links, hoe kleiner het getal. Dus -5 < -2.",
        "solutionSteps": [
          "Kijk op de getallenlijn: waar staan -5 en -2?",
          "-5 staat links van -2",
          "Hoe verder naar links, hoe kleiner het getal",
          "Dus -5 < -2 → -5 is kleiner"
        ],
        "distractorExplanations": {
          "0": "Goed! -5 staat links van -2 op de getallenlijn, dus -5 is kleiner.",
          "1": "Je dacht waarschijnlijk: 5 > 2, dus -5 > -2. Maar bij negatieve getallen geldt het omgekeerde: hoe groter het getal achter het minteken, hoe kleiner het getal. Onthoud: kijk op de getallenlijn — hoe verder naar links, hoe kleiner.",
          "2": "Je dacht waarschijnlijk dat -5 en -2 even groot zijn. Maar -5 staat links van -2 op de getallenlijn, dus -5 is kleiner dan -2. Onthoud: twee verschillende getallen zijn nooit even groot.",
          "3": "Je kunt het wél zeggen. Gebruik de getallenlijn: -5 staat links van -2, dus -5 < -2. Onthoud: op de getallenlijn geldt altijd: links = kleiner."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-002",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -3 + 5 =",
      "context": null,
      "options": ["2", "-2", "8", "-8"],
      "correctAnswer": 0,
      "conceptId": "negative_add_positive",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-3, 0, 2],
            "label": "Getallenlijn: -3 + 5",
            "start": -5,
            "end": 10
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-3, 0, 2],
            "highlight": [2],
            "arrows": [
              {
                "from": -3,
                "to": 2,
                "label": "Start bij -3, ga 5 stappen naar rechts → 2"
              }
            ],
            "label": "Begin bij -3. Tel 5 op = ga 5 stappen naar rechts. Uitkomst: 2",
            "start": -5,
            "end": 10
          }
        }
      ],
      "feedback": {
        "explanationText": "Begin bij -3 op de getallenlijn. Optellen = naar rechts gaan. Ga 5 stappen naar rechts: -3 → -2 → -1 → 0 → 1 → 2. Dus -3 + 5 = 2.",
        "solutionSteps": [
          "Begin bij -3 op de getallenlijn",
          "Optellen = naar rechts gaan",
          "Ga 5 stappen naar rechts: -3 → -2 → -1 → 0 → 1 → 2",
          "Je passeert nul en komt uit op +2",
          "Dus -3 + 5 = 2"
        ],
        "distractorExplanations": {
          "0": "Goed! Begin bij -3, ga 5 stappen naar rechts: -3 + 5 = 2.",
          "1": "Je dacht waarschijnlijk dat het antwoord negatief is. Maar begin bij -3 op de getallenlijn en ga 5 stappen naar rechts — je passeert nul en komt uit op +2. Onthoud: optellen = naar rechts, ook als je begint bij een negatief getal.",
          "2": "Je dacht waarschijnlijk dat -3 + 5 = 8. Maar je begint bij -3, niet bij 3. Begin bij -3 en ga 5 stappen naar rechts: -3 + 5 = 2. Onthoud: het minteken vóór de 3 betekent dat je links van nul begint.",
          "3": "Je dacht waarschijnlijk dat je -3 + (-5) = -8 moest berekenen. Maar je telt op (+5), niet af. Begin bij -3, ga 5 stappen naar rechts: -3 + 5 = 2. Onthoud: + betekent naar rechts op de getallenlijn."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-003",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: 4 - 7 =",
      "context": null,
      "options": ["-3", "3", "11", "-11"],
      "correctAnswer": 0,
      "conceptId": "negative_result_subtraction",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-3, 0, 4],
            "label": "Getallenlijn: 4 - 7",
            "start": -5,
            "end": 10
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-3, 0, 4],
            "highlight": [-3],
            "arrows": [
              {
                "from": 4,
                "to": -3,
                "label": "Start bij 4, ga 7 stappen naar links → -3"
              }
            ],
            "label": "Begin bij 4. Trek 7 af = ga 7 stappen naar links. Je passeert nul: uitkomst -3",
            "start": -5,
            "end": 10
          }
        }
      ],
      "feedback": {
        "explanationText": "Begin bij 4 op de getallenlijn. Aftrekken = naar links gaan. Ga 7 stappen naar links: 4 → 3 → 2 → 1 → 0 → -1 → -2 → -3. Je passeert nul en komt in het negatieve gebied: 4 - 7 = -3.",
        "solutionSteps": [
          "Begin bij 4 op de getallenlijn",
          "Aftrekken = naar links gaan",
          "Ga 7 stappen naar links: 4 → 3 → 2 → 1 → 0 → -1 → -2 → -3",
          "Je passeert nul en komt in het negatieve gebied",
          "Dus 4 - 7 = -3"
        ],
        "distractorExplanations": {
          "0": "Goed! Begin bij 4, ga 7 stappen naar links, je passeert nul: 4 - 7 = -3.",
          "1": "Je dacht waarschijnlijk dat 4 - 7 hetzelfde is als 7 - 4 = 3. Maar de volgorde maakt uit: 4 - 7 ≠ 7 - 4. Begin bij 4 en ga 7 stappen naar links: je passeert nul en komt uit op -3. Onthoud: je mag de getallen bij aftrekken niet omdraaien.",
          "2": "Je dacht waarschijnlijk dat je 4 + 7 = 11 moest berekenen. Maar er staat een minteken: je trekt 7 af (naar links), je telt niet op. Onthoud: - = naar links op de getallenlijn.",
          "3": "Je dacht waarschijnlijk dat het getal -4 is in plaats van +4. Maar het getal is +4 (positief). Begin bij +4 en ga 7 stappen naar links: 4 - 7 = -3. Onthoud: een getal zonder minteken is altijd positief."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-004",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -3 × 4 =",
      "context": null,
      "options": ["-12", "12", "-7", "7"],
      "correctAnswer": 0,
      "conceptId": "negative_multiply_positive",
      "variantIndex": 4,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-12, -9, -6, -3, 0],
            "label": "Getallenlijn: -3 × 4 = vier keer -3",
            "start": -15,
            "end": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-12, -9, -6, -3, 0],
            "highlight": [-12],
            "arrows": [
              { "from": 0, "to": -3, "label": "1× -3" },
              { "from": -3, "to": -6, "label": "2× -3" },
              { "from": -6, "to": -9, "label": "3× -3" },
              { "from": -9, "to": -12, "label": "4× -3 = -12" }
            ],
            "label": "Regel: negatief × positief = negatief. 4 keer -3 = -12",
            "start": -15,
            "end": 5
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken eerst het getal zonder teken: 3 × 4 = 12. Bepaal dan het teken: negatief × positief = negatief. Dus -3 × 4 = -12.",
        "solutionSteps": [
          "Bereken zonder teken: 3 × 4 = 12",
          "Bepaal het teken: negatief × positief = negatief",
          "Dus -3 × 4 = -12"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 4 = 12, en negatief × positief = negatief, dus -3 × 4 = -12.",
          "1": "Je dacht waarschijnlijk dat het antwoord positief is. Maar 3 × 4 = 12 klopt, en -3 × 4 geeft een negatief antwoord: negatief × positief = negatief. Onthoud: één minteken in een vermenigvuldiging geeft een negatief antwoord.",
          "2": "Je dacht waarschijnlijk dat je -3 + (-4) = -7 moest berekenen. Maar er staat een × (vermenigvuldiging). Bereken: 3 × 4 = 12, en negatief × positief = negatief, dus -12. Onthoud: × is vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat het antwoord 7 is. Maar er staat een × (vermenigvuldiging): 3 × 4 = 12, en negatief × positief = negatief, dus -3 × 4 = -12. Onthoud: kijk altijd goed welk rekenteken er staat."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-005",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -2 × -5 =",
      "context": null,
      "options": ["10", "-10", "7", "-7"],
      "correctAnswer": 0,
      "conceptId": "negative_multiply_negative",
      "variantIndex": 5,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.8,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [0, 5, 10],
            "label": "Getallenlijn: -2 × -5 = +10",
            "start": -5,
            "end": 15
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [0, 10],
            "highlight": [10],
            "label": "Regel: negatief × negatief = positief. -2 × -5 = +10",
            "start": -5,
            "end": 15
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken eerst het getal zonder teken: 2 × 5 = 10. Bepaal dan het teken: negatief × negatief = positief (twee mintekens heffen elkaar op). Dus -2 × -5 = +10.",
        "solutionSteps": [
          "Bereken zonder teken: 2 × 5 = 10",
          "Bepaal het teken: negatief × negatief = positief",
          "Twee mintekens heffen elkaar op",
          "Dus -2 × -5 = +10"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 × 5 = 10, en negatief × negatief = positief, dus -2 × -5 = +10.",
          "1": "Je dacht waarschijnlijk dat negatief × negatief negatief geeft. Maar twee mintekens heffen elkaar op: negatief × negatief = positief. Onthoud: twee mintekens samen = plusteken.",
          "2": "Je dacht waarschijnlijk dat je -2 + 5 moest berekenen. Maar er staat een × (vermenigvuldiging): 2 × 5 = 10, en negatief × negatief = positief, dus +10. Onthoud: × is vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je -2 + (-5) = -7 moest berekenen. Maar er staat een × (vermenigvuldiging): 2 × 5 = 10, en negatief × negatief = positief, dus +10. Onthoud: kijk altijd goed welk rekenteken er staat."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-006",
      "familyId": "GET-NEGATIEF",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Bereken: -20 ÷ 4 =",
      "context": null,
      "options": ["-5", "5", "-16", "16"],
      "correctAnswer": 0,
      "conceptId": "negative_divide_positive",
      "variantIndex": 6,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.77,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "marked": [-20, -15, -10, -5, 0],
            "label": "Getallenlijn: -20 ÷ 4",
            "start": -25,
            "end": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "marked": [-20, -15, -10, -5, 0],
            "highlight": [-5],
            "arrows": [
              {
                "from": -20,
                "to": -5,
                "label": "-20 gedeeld in 4 gelijke delen = -5 per deel"
              }
            ],
            "label": "Regel: negatief ÷ positief = negatief. -20 ÷ 4 = -5",
            "start": -25,
            "end": 5
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken eerst het getal zonder teken: 20 ÷ 4 = 5. Bepaal dan het teken: negatief ÷ positief = negatief. Dus -20 ÷ 4 = -5.",
        "solutionSteps": [
          "Bereken zonder teken: 20 ÷ 4 = 5",
          "Bepaal het teken: negatief ÷ positief = negatief",
          "Dus -20 ÷ 4 = -5"
        ],
        "distractorExplanations": {
          "0": "Goed! 20 ÷ 4 = 5, en negatief ÷ positief = negatief, dus -20 ÷ 4 = -5.",
          "1": "Je dacht waarschijnlijk dat het antwoord positief is. Maar 20 ÷ 4 = 5 klopt, en -20 ÷ 4 geeft een negatief antwoord: negatief ÷ positief = negatief. Onthoud: één minteken bij delen geeft een negatief antwoord.",
          "2": "Je dacht waarschijnlijk dat je -20 + 4 = -16 moest berekenen. Maar er staat een ÷ (delen): 20 ÷ 4 = 5, en negatief ÷ positief = negatief, dus -5. Onthoud: ÷ is delen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je -20 + 4 = -16 moest berekenen en dan het teken omdraaide. Maar er staat een ÷ (delen): 20 ÷ 4 = 5, en negatief ÷ positief = negatief, dus -20 ÷ 4 = -5. Onthoud: kijk altijd goed welk rekenteken er staat."
        }
      }
    }
  ]
}
